import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SearchServices } from "../../../../context/Slice/ServiceManagementSlice";
import {
  AddEventVendors,
  AddVendorEvent,
} from "../../../../context/Slice/EventManagementSlice";
import {
  ShowAllServiceLocation,
  ShowAllCategories,
} from "../../../../context/Slice/VendorManagementSlice";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import "./AddVendorForm.css";
import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode";
import { Button } from "@mui/material";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AddVendorForm = () => {
  const location = useLocation();
  const { selectedEvent } = location.state || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const locations = useSelector((state) => state.VendorManagementR.AllLoc);
  const categories = useSelector((state) => state.VendorManagementR.AllCat);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [vendorData, setVendorData] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [ID, setID] = useState("");
  const token = secureLocalStorage.getItem("token");
  const [eventVendors, setEventVendors] = useState(
    selectedEvent?.Event_Vendors || []
  );

  const HandleBack = () => {
    navigate("/co-ordinator-dashboard/User-InQuiry");
  };
  console.log("selectedEvent---->", selectedEvent);

  useEffect(() => {
    if (token) {
      const decoded = jwtDecode(token);
      const ID = decoded._id;
      setID(ID);
    }
    dispatch(ShowAllServiceLocation());
    dispatch(ShowAllCategories());
  }, [dispatch, token]);
  console.log("id", ID);
  if (!selectedEvent) {
    return <p>No event selected.</p>;
  }

  const handleCategoryChange = (option) => {
    setSelectedCategory(option);
  };

  const handleLocationChange = (option) => {
    setSelectedLocation(option);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(
        SearchServices({
          CategorieName: selectedCategory?.label,
          ServiceLocations: selectedLocation?.label,
        })
      );

      const searchData = response.payload.VendorServices;
      setVendorData(searchData);
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  const handleSelectVendor = (vendor) => {
    setSelectedVendors((prevSelected) => [...prevSelected, vendor]);
  };

  const getImagePath = (vendor) => {
    try {
      const images = JSON.parse(vendor.Image);
      if (images && images.length > 0) {
        return `${BASE_URL}/uploads/${images[0].filename}`;
      }
    } catch (error) {
      console.error("Error parsing vendor image:", error);
    }
    return "assets/dummyProfile.jpg"; // Fallback image
  };

  const calculateTotalBudget = () => {
    let totalBudget = 0;
    if (selectedEvent?.Budget?.categories) {
      selectedEvent.Budget.categories.forEach((category) => {
        totalBudget += parseInt(category.price, 10);
      });
    }
    return totalBudget;
  };
console.log(selectedVendors)
  const handleAddToEvent = () => {
    const selectedVendorsData = selectedVendors.map((vendor, index) => ({
      VendorNo: index + 1,
      VendorID: vendor.Vendor_ID,
      serviceName: vendor.ServiceName,
      // startPriceRange: vendor.StartpriceRange,
      // endPriceRange: vendor.EndpriceRange,
      // address: vendor.Address,
      // city: vendor.City,
      startPriceRange: vendor.TotalBudget,
      address: vendor.Location,
      city: JSON.parse(vendor.ServiceLocations).join(", ") ,
      category: vendor.Category.CategorieName,
      email: vendor.VendorDetails?.OwnerEmail || "N/A",
      mobileNumber: vendor.VendorDetails?.OwnerMobile_number || "N/A",
      whatsappNumber: vendor.VendorDetails?.OwnerWhatsapp_number || "N/A",
    }));

    const eventVendorsData = eventVendors.map((vendor, index) => ({
      VendorNo: index + 1,
      VendorID: vendor.VendorID,
      serviceName: vendor.serviceName,
      // startPriceRange: vendor.startPriceRange,
      // endPriceRange: vendor.endPriceRange,
      // address: vendor.address,
      // city: vendor.city,
      startPriceRange: vendor.TotalBudget,
      address: vendor.Location,
      city: JSON.parse(vendor.ServiceLocations).join(", ") ,
      category: vendor.category || "N/A",
      email: vendor.email || "N/A",
      mobileNumber: vendor.mobileNumber || "N/A",
      whatsappNumber: vendor.whatsappNumber || "N/A",
    }));

    const combinedVendorsData = [...selectedVendorsData, ...eventVendorsData];
    console.log("ID", selectedEvent.id);
    console.log("put", combinedVendorsData);

    const jsonVendorsData = JSON.stringify(combinedVendorsData, null, 2);
    console.log(jsonVendorsData);

    dispatch(
      AddEventVendors({
        ID: selectedEvent.id,
        selectedVendorsData: selectedVendorsData,
      })
    )
      .then(() => {
        // ✅ Move Selected Vendors to Previous Vendors after API success
        setEventVendors(combinedVendorsData);
        setSelectedVendors([]); // Clear selected vendors
      })
      .catch((error) => {
        console.error("Failed to add vendors:", error);
      });
    
  };
  

  const handleRemoveVendor = (vendorToRemove, fromSelected = true) => {
    if (fromSelected) {
      setSelectedVendors((prevSelected) =>
        prevSelected.filter((vendor) => vendor !== vendorToRemove)
      );
    } else {
      const updatedEventVendors = eventVendors.filter(
        (vendor) => vendor !== vendorToRemove
      );
      setEventVendors(updatedEventVendors);
    }
  };

  const handleSendInfo = (fromSelected) => {
    const EventData = {
      Vendor_ID: fromSelected.VendorID || "NA",
      serviceName: fromSelected.serviceName || "NA",
      Coordinator_id: selectedEvent.Coordinator_id || "NA",
      Event_id: selectedEvent.id || "NA",
      Event_Name: selectedEvent.EventName || "NA",
      Start_date: selectedEvent.Start_Date || "NA",
      End_date: selectedEvent.End_Date || "NA",
      Proposed_Date: selectedEvent.Proposed_Date || "NA",
      Guest: selectedEvent.Guest || "NA",
    };
    console.log("EventData", EventData);

    dispatch(AddVendorEvent(EventData));
  };

  return (
    <div id="AddVendorForm">
      <div>
      <Button
          variant="contained"
          color="secondary"
          onClick={HandleBack}
          sx={{ position: "absolute", top: "20px", left: "20px" }}
        >
          Back
        </Button>
        <h2 className="heading mt-5">Add Vendors</h2>
      </div>
      <div className="row">
        <div className="col-4">
          <div className="grid">
            <div className="card">
              <div className="card-body">
                <h3 className=" text-center mb-5 fw-bold">Event Details</h3>
                <h5 className="card-title fw-bold">
                  {selectedEvent.EventName}
                </h5>
                <p className="card-text">
                  <strong>Name:</strong> {selectedEvent.User.firstName}{" "}
                  {selectedEvent.User.lastName}
                </p>
                <p className="card-text">
                  <strong>Email:</strong> {selectedEvent.User.email}
                </p>
                <p className="card-text">
                  <strong>Mobile:</strong> {selectedEvent.User.mobile_number}
                </p>
                <p className="card-text">
                  <strong>Notes:</strong> {selectedEvent.Description}
                </p>
                <p className="card-text">
                  <strong>Proposed Date:</strong> {selectedEvent.Proposed_Date}
                </p>
                <p className="card-text">
                  <strong>Start Date:</strong> {selectedEvent.Start_Date}
                </p>
                <p className="card-text">
                  <strong>End Date:</strong> {selectedEvent.End_Date}
                </p>
                <div>
                  <h2 className="text-center">Categories</h2>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedEvent.Budget.categories.map(
                        (category, index) => (
                          <tr key={index}>
                            <td>{category.type}</td>
                            <td>{category.price}</td>
                          </tr>
                        )
                      )}
                      <tr>
                        <td>
                          <strong>Total</strong>
                        </td>
                        <td>
                          <strong>{calculateTotalBudget()}</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="card mt-4">
              <div className="card-body">
                <h5 className="card-title fw-bold">
                  Previous Selected Vendors
                </h5>
                {eventVendors.length === 0 ? (
                  <p>No vendors selected.</p>
                ) : (
                  eventVendors.map((vendor, index) => (
                    <div className="mt-5" key={index}>
                      <p>
                        <strong>Vendor No:</strong> {index + 1}
                      </p>
                      <h5 className="card-title">{vendor.serviceName}</h5>
                      {/* <p>
                        <strong>Start Price Range :</strong> {vendor.TotalBudget}
                      </p> */}
                      {/* <p>
                        <strong>End Price Range :</strong>{" "}
                        {vendor.endPriceRange}
                      </p> */}
                      {/* <p>
                        <strong>Address :</strong> {vendor.Location}
                      </p> */}
                      <p>
                        <strong>City :</strong> {vendor.city}
                      </p>
                      <p>
                        <strong>Category :</strong> {vendor.category}
                      </p>
                      <p>
                        <strong>Email :</strong> {vendor.email || "N/A"}
                      </p>
                      <p>
                        <strong>Mobile Number :</strong>{" "}
                        {vendor.mobileNumber || "N/A"}
                      </p>
                      <p>
                        <strong>Whatsapp Number :</strong>{" "}
                        {vendor.whatsappNumber || "N/A"}
                      </p>

                      <button
                        onClick={() => handleSendInfo(vendor)}
                        className="btn btn-danger"
                        style={{ marginRight: "10px" }}
                      >
                        Send Event Info
                      </button>

                      <button
                        onClick={() => handleRemoveVendor(vendor, false)}
                        className="btn btn-danger"
                      >
                        Remove
                      </button>
                    </div>
                  ))
                )}
              </div>
            </div>
            <div className="card mt-4">
              <div className="card-body">
                <h5 className="card-title fw-bold">Selected Vendors</h5>
                {selectedVendors.length === 0 ? (
                  <p>No vendors selected.</p>
                ) : (
                  selectedVendors.map((vendor, index) => (
                    <div className="mt-5" key={index}>
                      <p>
                        <strong>Vendor No:</strong> {index + 1}
                      </p>
                      <h5 className="card-title">{vendor.ServiceName}</h5>
                      <p>
                        <strong>Start Price Range :</strong>{" "}
                        {vendor.TotalBudget}
                      </p>
                      {/* <p>
                        <strong>End Price Range :</strong>{" "}
                        {vendor.EndpriceRange}
                      </p> */}
                      <p>
                        <strong>Address :</strong> {vendor.Location}
                      </p>
                      <p>
                        <strong>Service Location :</strong>{" "}
                        {vendor.ServiceLocations
                          ? JSON.parse(vendor.ServiceLocations).join(", ")
                          : "N/A"}
                      </p>
                      <p>
                        <strong>Category :</strong>{" "}
                        {vendor.Category.CategorieName}
                      </p>
                      <p>
                        <strong>Email :</strong>{" "}
                        {vendor.VendorDetails?.OwnerEmail || "N/A"}
                      </p>
                      <p>
                        <strong>Mobile Number :</strong>{" "}
                        {vendor.VendorDetails?.OwnerMobile_number || "N/A"}
                      </p>
                      <p>
                        <strong>Whatsapp Number :</strong>{" "}
                        {vendor.VendorDetails?.OwnerWhatsapp_number || "N/A"}
                      </p>
                      <button
                        onClick={() => handleRemoveVendor(vendor)}
                        className="btn btn-danger"
                      >
                        Remove
                      </button>
                    </div>
                  ))
                )}
                <button
                  onClick={handleAddToEvent}
                  className="btn btn-primary center w-100"
                >
                  Add in Event
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-8">
          <form className="form-container" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="category">Category</label>
              <Select
                placeholder="Select category"
                options={categories.map((category) => ({
                  label: category.CategorieName.toUpperCase(),
                  value: category.id,
                }))}
                onChange={handleCategoryChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="city">City</label>
              <Select
                placeholder="Select location"
                options={locations.map((location) => ({
                  value: location.LocationName.toUpperCase(),
                  label: location.LocationName.toUpperCase(),
                }))}
                onChange={handleLocationChange}
              />
            </div>

            <button type="submit" className="btn btn-primary mb-4">
              Search
            </button>
          </form>
          <div className="coloum mt-5">
            {vendorData.length === 0 ? (
              <p>No vendors found for the selected filters.</p>
            ) : (
              vendorData.map((vendor, index) => (
                <div className="card" key={index}>
                  <img
                    src={getImagePath(vendor)}
                    className="card-img-top"
                    alt="Vendor"
                  />
                  <div className="card-body">
                    <h5 className="card-title">{vendor.ServiceName}</h5>
                    <p>
                      <strong>Price Range :</strong> {vendor.TotalBudget}
                    </p>
                    {/* <p>
                      <strong>End Price Range :</strong> {vendor.EndpriceRange}
                    </p> */}
                    <p>
                      <strong>Address :</strong> {vendor.Location}
                    </p>
                    <p>
                      <strong>Service Location :</strong>{" "}
                      {vendor.ServiceLocations
                        ? JSON.parse(vendor.ServiceLocations).join(", ")
                        : "N/A"}
                    </p>
                    <p>
                      <strong>Category :</strong>{" "}
                      {vendor.Category.CategorieName}
                    </p>
                    <p>
                      <strong>Email :</strong>{" "}
                      {vendor.VendorDetails?.OwnerEmail || "N/A"}
                    </p>
                    <p>
                      <strong>Mobile Number :</strong>{" "}
                      {vendor.VendorDetails?.OwnerMobile_number || "N/A"}
                    </p>
                    <p>
                      <strong>Whatsapp Number :</strong>{" "}
                      {vendor.VendorDetails?.OwnerWhatsapp_number || "N/A"}
                    </p>
                    <button
                      onClick={() => handleSelectVendor(vendor)}
                      className="btn btn-primary"
                    >
                      Select
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddVendorForm;
